import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
`;
